var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableProfitRedArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.817316C9.779 0.817316 9.559 0.889316 9.375 1.03632L5.074 4.47732L1.707 1.11032C1.316 0.719316 0.683998 0.719316 0.292998 1.11032C-0.0980018 1.50132 -0.0980018 2.13332 0.292998 2.52432L4.293 6.52432C4.654 6.88532 5.228 6.91632 5.625 6.59832L9.926 3.15732L19.293 12.5243C19.684 12.9153 20.316 12.9153 20.707 12.5243C21.098 12.1333 21.098 11.5013 20.707 11.1103L10.707 1.11032C10.513 0.916315 10.257 0.817316 10 0.817316Z",
    fill: "#B44A73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.176 13.4003C22.203 13.5653 22.15 13.7323 22.031 13.8493C21.914 13.9673 21.747 14.0203 21.583 13.9933L18.992 13.5673C18.801 13.5353 18.643 13.4003 18.585 13.2153C18.525 13.0313 18.574 12.8293 18.711 12.6923L20.875 10.5283C21.012 10.3913 21.214 10.3423 21.398 10.4023C21.582 10.4623 21.717 10.6193 21.749 10.8103L22.176 13.4003Z",
    fill: "#B44A73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableProfitRedArrowIcon);
export default __webpack_public_path__ + "static/media/table_profit_red_arrow_icon.7bda8e55.svg";
export { ForwardRef as ReactComponent };